import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import parse from 'html-react-parser';
import LazyLoad from 'react-lazyload';
import { styles } from '@utils';
import breakpoints from '@repo/ui-components/breakpoints';
import Button from '@repo/ui-components/button/Button';
import PageWrapper from '@repo/ui-components/page-wrapper/PageWrapper';

const Heading = styled.h2`
  font-weight: ${styles.fontWeight.medium};
`;

const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: ${breakpoints.xl};
  margin: 0 auto;
  flex-flow: ${({ layout }) =>
    layout === 'right' ? 'column-reverse' : 'column'};

  @media screen and (min-width: ${breakpoints.md}) {
    img {
      width: 100%;
    }
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    flex-direction: ${({ layout }) =>
      layout === 'right' ? 'row' : 'row-reverse'};
  }
`;

const InnerSection = styled.div`
  display: block;
  flex-wrap: wrap;
  align-content: center;
  padding: 1rem 1.625rem;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  &.image-section {
    display: flex;
    width: 100%;
    padding: 0;
    justify-content: center;
  }

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    width: 50%;

    &.image-section {
      width: 50%;
    }

    p {
      padding-right: 4.25rem;
    }
  }
`;

const FeatureRow = ({ settings, CDN_URL }) => (
  <PageWrapper fullWidth background={styles.colors.gray[100]} padding="0">
    <LazyLoad height="100%">
      <InnerContainer layout={settings.layout}>
        <InnerSection>
          <Heading>{settings.title}</Heading>
          {parse(settings.text)}
          <Button
            onClick={() =>
              navigate(
                settings.button_link
                  .replace('shopify://pages/', '/')
                  .replace('shopify://collections/', '')
                  .replace('shopify://products/', '/')
                  .replace('shopify://blogs/news/', 'blog/')
                  .replace('shopify://policies', '/')
              )
            }
          >
            {settings.button_label}
          </Button>
        </InnerSection>
        <InnerSection className="image-section">
          <img
            src={`${settings.image.replace(
              'shopify://shop_images/',
              CDN_URL
            )}?height=519`}
            alt={settings.button_label}
            width="601"
            height="519"
          />
        </InnerSection>
      </InnerContainer>
    </LazyLoad>
  </PageWrapper>
);

FeatureRow.propTypes = {
  settings: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    button_link: PropTypes.string,
    button_label: PropTypes.string,
    image: PropTypes.string,
    layout: PropTypes.string,
  }).isRequired,
  CDN_URL: PropTypes.string.isRequired,
};

export default FeatureRow;
